import React, { FC } from 'react'
import { CheckIcon } from './Icon'
import { Wrapper, Info, Title, Text } from './styled'

interface ComponentProps {
	title: string
	text: string
	isIcon?: boolean
	isCustomIconColor?: boolean
	className?: string
}

export const AdvantagesElement: FC<ComponentProps> = ({
	title,
	text,
	isIcon = true,
	isCustomIconColor = false,
	className,
}) => (
	<Wrapper className={className}>
		{isIcon && <CheckIcon isCustomIconColor={isCustomIconColor} />}
		<Info>
			<Title>{title}</Title>
			<Text>{text}</Text>
		</Info>
	</Wrapper>
)
